import { useState } from 'react'

import { Box, Button, FontsWeights, Text } from '@factorialco/deprecated-design-system'
import { AvailableModules } from 'generated/featureDefinitions'
import { PerformanceProcessAgreementCourseFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import CourseRequestWizard from 'modules/performance_process/components/CourseRequestWizard'
import trainingsUpsell from 'modules/performance_process/lib/assets/trainingsUpsell.png'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

import { TrainingRequestItem } from './TrainingRequestItem'

export const AgreementCourse = ({
  agreement,
  HeaderComponent = Text.Normal,
}: {
  agreement: PerformanceProcessAgreementCourseFragment
  HeaderComponent?: React.ComponentType<{ children: React.ReactNode; weight: FontsWeights }>
}) => {
  const [isWizardVisible, setIsWizardVisible] = useState(false)

  const trainingRequests = agreement.agreementTrainingRequests ?? []
  const canAddTrainingRequest = agreement._policies?.addTrainingRequest?.can

  if (!canAddTrainingRequest && trainingRequests.length === 0) return null

  return (
    <Box gap="s24">
      <HeaderComponent weight="semibold">
        {i18n.t('performance_process.targets.suggested_courses')}
      </HeaderComponent>
      {trainingRequests.map(({ trainingRequest }, index) => (
        <TrainingRequestItem
          trainingRequest={trainingRequest}
          index={index + 1}
          key={trainingRequest.id}
        />
      ))}
      {isWizardVisible && (
        <CourseRequestWizard onClose={() => setIsWizardVisible(false)} agreement={agreement} />
      )}
      {!agreement.locked && (
        <Box width="fit-content">
          <UpsellingKit.ProductWidgetPopover
            label={i18n.t('performance_process.targets.request_new_course')}
            mediaUrl={trainingsUpsell}
            variant="outlinePromote"
            title={i18n.t('upsell_trainings.popover.title')}
            description={i18n.t('upsell_trainings.popover.description')}
            requestSource="Performance - suggested courses"
            moduleRequested={AvailableModules.trainings}
            requestReason={ValidReasons.MissingAddon}
            fallbackComponent={
              canAddTrainingRequest && (
                <Box gap="s12" className="flex justify-start">
                  <Button type="secondary" iconName="add" onClick={() => setIsWizardVisible(true)}>
                    {i18n.t('performance_process.targets.request_new_course')}
                  </Button>
                </Box>
              )
            }
          />
        </Box>
      )}
    </Box>
  )
}
